import React from 'react';
import "../../../styles.css";
import audioimg from '../../../assets/audio-waves.png';
import returnimg from '../../../assets/undo.png';
import { Link } from "react-router-dom";
import simg from '../../../assets/real_letters/s.jpg';
import mimg from '../../../assets/real_letters/m.jpg';
import timg from '../../../assets/real_letters/t.jpg';
import pimg from '../../../assets/real_letters/p.jpg';
import nimg from '../../../assets/real_letters/n.jpg';
import cimg from '../../../assets/real_letters/c.jpg';
import kimg from '../../../assets/real_letters/k.jpg';
import rimg from '../../../assets/real_letters/r.jpg';
import bimg from '../../../assets/real_letters/b.jpg';
import jimg from '../../../assets/real_letters/j.jpg';
import fimg from '../../../assets/real_letters/f.jpg';
import gimg from '../../../assets/real_letters/g.jpg';
import himg from '../../../assets/real_letters/h.jpg';
import dimg from '../../../assets/real_letters/d.jpg';
import wimg from '../../../assets/real_letters/w.jpg';
import vimg from '../../../assets/real_letters/v.jpg';
import limg from '../../../assets/real_letters/l.jpg';
import yimg from '../../../assets/real_letters/y.jpg';
import sphoneme from '../../../assets/phonemes/s.mp3'
import mphoneme from '../../../assets/phonemes/m.mp3'
import tphoneme from '../../../assets/phonemes/t.mp3'
import pphoneme from '../../../assets/phonemes/p.mp3'
import nphoneme from '../../../assets/phonemes/n.mp3'
import cphoneme from '../../../assets/phonemes/c.mp3'
import kphoneme from '../../../assets/phonemes/k.mp3'
import rphoneme from '../../../assets/phonemes/r.mp3'
import bphoneme from '../../../assets/phonemes/b.mp3'
import jphoneme from '../../../assets/phonemes/j.mp3'
import fphoneme from '../../../assets/phonemes/f.mp3'
import gphoneme from '../../../assets/phonemes/g.mp3'
import hphoneme from '../../../assets/phonemes/h.mp3'
import dphoneme from '../../../assets/phonemes/d.mp3'
import wphoneme from '../../../assets/phonemes/w.mp3'
import vphoneme from '../../../assets/phonemes/v.mp3'
import lphoneme from '../../../assets/phonemes/l.mp3'
import yphoneme from '../../../assets/phonemes/y.mp3'

const letterImages = {
    's': simg,
    'm': mimg,
    't': timg,
    'p': pimg,
    'n': nimg,
    'c': cimg,
    'k': kimg,
    'r': rimg,
    'b': bimg,
    'j': jimg,
    'f': fimg,
    'g': gimg,
    'h': himg,
    'd': dimg,
    'w': wimg,
    'v': vimg,
    'l': limg,
    'y': yimg
}

const sounds = {
    's': sphoneme,
    'm': mphoneme,
    't': tphoneme,
    'p': pphoneme,
    'n': nphoneme,
    'c': cphoneme,
    'k': kphoneme,
    'r': rphoneme,
    'b': bphoneme,
    'j': jphoneme,
    'f': fphoneme,
    'g': gphoneme,
    'h': hphoneme,
    'd': dphoneme,
    'w': wphoneme,
    'v': vphoneme,
    'l': lphoneme,
    'y': yphoneme
}

function LetterQuestion(props) {
    const audio = new Audio(sounds[props.letter])
    return (
        <div className='question'>
            <Link to='/Level Select' className='leftButton'><img className='imagesInDivs' src={returnimg} alt="BACK" onClick={() => props.resetVariables()} /></Link>
            <div className='questionImage' style={{ border: 'hidden' }}>
                <img src={letterImages[props.letter]} className='imagesInDivs' alt='Letter' />
            </div>
            <button className='rightButton'><img className='imagesInDivs' src={audioimg} alt="AUDIO" onClick={handleAudio} /></button>
        </div>
    );

    function handleAudio() {
        audio.play();
    }
}

export default LetterQuestion;